import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-kanban-menu-actions',
  templateUrl: './kanban-menu-actions.component.html',
  styleUrls: ['./kanban-menu-actions.component.scss']
})
export class KanbanMenuActionsComponent implements OnInit {
  @Input() node;
  @Input() doDisplayPermissions: boolean;
  @Output('remove') removeNode: EventEmitter<any>;
  @Output('add') addNode: EventEmitter<any>;
  @Output('update') updateNode: EventEmitter<any>;
  @Output('duplicate') duplicateNode: EventEmitter<any>;
  @Output('archive') archiveNode: EventEmitter<any>;
  @Output('notify') notifyNode: EventEmitter<any>;
  @Output('see') seeNode: EventEmitter<any>;
  @Output('permissions') permissions: EventEmitter<any>;
  @Output('makeModel') makeModel: EventEmitter<any>;
  @Output('edit') edit: EventEmitter<any>;
  @Output('delete') delete: EventEmitter<any>;


  constructor() {
    this.removeNode = new EventEmitter<any>();
    this.addNode = new EventEmitter<any>();
    this.updateNode = new EventEmitter<any>();
    this.archiveNode = new EventEmitter<any>();
    this.notifyNode = new EventEmitter<any>();
    this.seeNode = new EventEmitter<any>();
    this.permissions = new EventEmitter<any>();
    this.duplicateNode = new EventEmitter<any>();
    this.makeModel = new EventEmitter<any>();
    this.edit = new EventEmitter<any>();
    this.delete = new EventEmitter<any>();

  }

  ngOnInit() {
    if (this.node.title == "Data tree") {
    }
  }
  sendPermissions() {
    this.permissions.emit();
  }
  sendEdit() {
    this.edit.emit();
  }
  sendDelete() {
    this.delete.emit();
  }
  makeAsModel() {
    this.makeModel.emit();
  }

  removeNodeTrigger() {
    this.removeNode.emit();
  }
  archiveNodeTrigger() {
    this.archiveNode.emit();
  }
  addNodeTrigger() {
    this.addNode.emit();
  }

  updateNodeTrigger() {
    this.updateNode.emit();
  }
  notifyNodeTrigger() {
    this.notifyNode.emit();
  }
  seeNodeTrigger() {
    this.seeNode.emit();
  }
  duplicateNodeTrigger() {
    this.duplicateNode.emit();
  }


}
